import React from "react";
import "./WhyUsSection.css";

const WhyUsSection: React.FC = () => {
  return (
    <section className="why-us">
      <div className="why-us-container">
        <h2 className="why-us-title">What set us apart?</h2>

        <div className="why-us-grid">
          <div className="why-us-item">
            <div className="why-us-icon">
              <img
                src="/assets-project/instant-processing-icon.svg"
                alt="Instant Processing"
              />
            </div>
            <h3 className="why-us-item-title">Instant Processing</h3>
            <p className="why-us-item-description">
              Payments are processed and deposited instantly to your bank
              account, no matter how customers pay.
            </p>
          </div>

          <div className="why-us-item">
            <div className="why-us-icon">
              <img
                src="/assets-project/no-hardware-icon.svg"
                alt="No Hardware"
              />
            </div>
            <h3 className="why-us-item-title">No Hardware</h3>
            <p className="why-us-item-description">
              Why buy extra hardware when the most powerful handheld device you
              can imagine is already in your pocket?
            </p>
          </div>

          <div className="why-us-item">
            <div className="why-us-icon">
              <img src="/assets-project/simple.svg" alt="Simple" />
            </div>
            <h3 className="why-us-item-title">Simple</h3>
            <p className="why-us-item-description">
              Only businesses need the app. Customers pay on their phone, and
              both sides receive automatic receipts.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
